export default "__VITE_ASSET__K3Hd4pjp__"